import React from 'react'
import PropTypes from 'prop-types'
import { TagIcon } from '@heroicons/react/outline'
import useAuth from '../../../hooks/useAuth'
import useRequest from '../../../hooks/useRequest'
import { Link } from 'react-router-dom'
import AppRoutes from '../../../routes/appRoutes'

const Deals = () => {
    return (
        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-yellow">
            <TagIcon className="w-4 h-4 stroke-current text-black90" />
        </div>
    )
}

const UsedEquipmentItem = ({ equipment }) => {
    const showDeals = equipment?.showDeals
    const equipmentName = `${equipment?.showEquipmentName}`
    const equipmentPrice = `$${equipment?.displayPrice}`
    const { user } = useAuth()
    const userId = user?.id
    const { handleMissingEquipmentImageLog } = useRequest()

    const imageErrorLog = (
        userId,
        imagePath,
        equipmentNumber,
        equipmentModel,
    ) => {
        const logInfo = {
            userId,
            imagePath,
            equipmentNumber,
            equipmentModel,
        }
        handleMissingEquipmentImageLog(logInfo)
    }

    return (
        <Link
            to={AppRoutes.usedEquipmentPage(equipment?.equipment)}
            className="overflow-hidden h-auto flex flex-col items-start justify-start gap-y-4 md:border-0 border border-grayLines md:rounded-none rounded-2xl md:bg-transparent bg-pgBackground md:p-0 p-4"
        >
            <div className="w-full h-auto pb-full relative">
                <img
                    className="w-full h-full absolute object-cover rounded-2xl"
                    src={equipment?.image}
                    onError={({ currentTarget }) => {
                        imageErrorLog(
                            userId,
                            equipment?.image,
                            equipment?.equipmenpt,
                            equipment?.model,
                        )
                        currentTarget.onerror = null
                        currentTarget.src = equipment.missingImage
                    }}
                />
            </div>
            <div className="w-full h-auto max-w-full flex items-center justify-between">
                <div className="w-full flex-grow h-auto flex flex-col items-start justify-start max-w-full gap-y-1">
                    <p className="text-base text-black90 font-medium">
                        {equipmentName}
                    </p>
                    <p className="text-textDarkGray font-medium text-sm">
                        {equipmentPrice}
                    </p>
                </div>
                {showDeals && <Deals />}
            </div>
        </Link>
    )
}

UsedEquipmentItem.propTypes = {
    equipment: PropTypes.object,
}

export default UsedEquipmentItem
